import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'

import TeamsStore from '../../../stores/teams'

import OrderableTH from '../../navigation/OrderableTH'
import StorePagination from '../../navigation/StorePagination'
import Icon from '../../util/Icon'

import { append } from '../../../utils/url'

@inject('auth')
@observer
export default class Teams extends Component {
  state = {
    search: '',
    order_by: 'created_at',
    order_dir: 'desc'
  }

  teams = new TeamsStore()

  componentWillMount() {
    this.loadPage()
  }

  componentDidMount() {
   this.searchField.focus()
  }

  loadPage(nextPage) {
    const { page=1 } = this.props.location.query
    this.teams.loadPage(nextPage || page, this.state)
  }

  componentWillReceiveProps(nextProps) {
    const { page:next, ...nextQuery } = nextProps.location.query
    const { page:prev, ...prevQuery } = this.props.location.query

    if (next !== prev) {
      this.loadPage(next)
    } else if (nextQuery.order_by !== prevQuery.order_by || nextQuery.order_dir !== prevQuery.order_dir) {
      this.setState(nextQuery, () => this.loadPage())
    }
  }

  handleSearch = ({ target: { value:search } }) => {
    this.setState({ search }, () => this.loadPage())
  }

  renderHasStripe(team) {
    if (team.stripe_subscription_id) {
      return (
        <Icon icon="cc-stripe" />
      )
    }
  }

  isAdmin() {
    return this.props.auth.user.admin
  }

  resellerHeading() {
    if (!this.isAdmin()) return null
    return (
      <OrderableTH query={this.state} field="reseller_teams.name">Reseller</OrderableTH>
    )
  }

  resellerRow(team) {
    if (!this.isAdmin()) return null
    return (
      <td>{team.reseller_team_name}</td>
    )
  }

  statusColor(team) {
    if (!team.license_status) {
      return '#fcaa3c'
    } else {
      return 'inherit'
    }
  }

  render() {
    const { search } = this.state

    return (
      <div className="container padded teams teams-admin">
        <div className="panel full padded">
          <h2 className="title">Teams</h2>
          <div className="table-actions">
            <input type="search" placeholder="Search by team/user name or email" value={search} onInput={this.handleSearch} ref={(el) => { this.searchField = el }}  />
          </div>

          <table className="zebra">
            <thead>
              <tr>
                <OrderableTH query={this.state} field="name">Name</OrderableTH>
                <th>Status</th>
                {this.resellerHeading()}
                <OrderableTH query={this.state} field="created_at" style={{ width: 150 }}>Created</OrderableTH>
              </tr>
            </thead>
            <tbody>
              {this.teams.map(t => {
                let display_status = t.license_status
                if (!display_status) {
                  if (t.reseller_direct_bill) {
                    display_status = 'new'
                  } else {
                    display_status = "new (hasn't started trial)"
                  }
                }
                return (
                  <tr key={t.id}>
                    <td><Link to={append(t.id)}>{t.name}</Link></td>
                    <td><Link to={append(t.id)} style={{ textTransform: 'uppercase', color:this.statusColor(t) }}>{display_status} {this.renderHasStripe(t)}</Link></td>
                    {this.resellerRow(t)}
                    <td>{new Date(t.created_at).toDateString()}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          <StorePagination store={this.teams} query={this.state} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/Teams/index.js